// extracted by mini-css-extract-plugin
module.exports = {"container":"_36IzluaCsySr1MvwXh9bXi","menuItem":"_3lrRTzzw-F_GDQyfRWUlyG"};